export default __webpack_public_path__ + "static/basics_baum-bed918e0cfd900c36e14124f108b8ada.jpg";